export { Newspaper as default } from './Newspaper';
